function sortArrayObject(data, key, sortDesc = true) {
  return data.sort(function (a, b) {
    const textA = a[key];
    const textB = b[key];

    if (sortDesc) {
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    } else {
      return textB < textA ? -1 : textB > textA ? 1 : 0;
    }
  });
}

function sortByDate(data, key) {
  const keyValue = key ? key : "createdDate";
  return data.sort(function (a, b) {
    return new Date(b[keyValue]).valueOf() - new Date(a[keyValue]).valueOf();
  });
}

export { sortArrayObject, sortByDate };
